import React, { useContext, useEffect, useState } from "react";
import {
  validateTokenTokStok,
  getQueryStringValue,
  authenticate,
  isAuth,
} from "../actions/auth";
import { getUser, updateUser } from "../actions/user";
import { createProjectByHashAsGift } from "../actions/project";
import { validateGift } from "../actions/gift";
import { brokenLink } from "../actions/logs";
import { useHistory, useParams } from "react-router-dom";
import {
  Row,
  Col,
  Form,
  Container,
  Card,
  CardBody,
  CardHeader,
  FormInput,
} from "shards-react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { makeStyles } from "@material-ui/core/styles";
import { BUCKET_URL } from "../config";
import { ShowLightbox } from "../components/common/ShowLightbox";

import CpfCnpj from "../components/common/CpfCnpj";
import PhoneBR from "../components/common/PhoneBR";
import LoadingOverlay from "react-loading-overlay";
import BounceLoader from "react-spinners/BounceLoader";
import { LANDING_PAGE_TOKSTOK } from "../config";
import {
  valida_cpf_cnpj,
  phoneValidation,
  emailValidation,
  getFormattedPhone,
} from "../utils/form_validation";
import { getDescendantProp } from "../utils/sanitize";
import { toast, ToastContainer } from "react-toastify";
import { getQuestionByHash } from "../actions/question";
import { authByForeignToken } from "../actions/authV2";
import { SystemContext } from "../components/SystemConfig/SystemContext";

function Gift() {
  const history = useHistory();
  const { label } = useParams();
  const { company } = useContext(SystemContext);
  const [user, setUser] = useState({
    profile: {
      firstName: "",
      lastName: "",
      phone: "",
    },
  });
  const [isLoading, setIsLoading] = useState(false);
  const [formValidations, setFormValidations] = useState({
    firstName: {
      validators: [required],
      isValid: true,
      accessor: "profile.firstName",
    },
    lastName: {
      validators: [required],
      isValid: true,
      accessor: "profile.lastName",
    },
    email: {
      validators: [required, emailValidation],
      isValid: true,
    },
    document: {
      validators: [required, valida_cpf_cnpj],
      isValid: true,
      accessor: "profile.document",
    },
    phone: {
      validators: [required, phoneValidation],
      isValid: true,
      accessor: "profile.phone",
    },
  });
  const projectTemplatesHash = getQueryStringValue("environment");
  const [questionInfo, setQuestionInfo] = useState();

  const steps = [
    "Escolha dos ambientes",
    "Informações pessoais",
    "Início da assessoria",
  ];
  const [lightbox, setLightbox] = useState({
    open: false,
    index: 0,
    images: [],
  });

  const useStyles = makeStyles(() => ({
    iconApproved: {
      color: "#0a775a !important",
    },
    iconWaiting: {
      color: "#656f6c !important",
    },
    iconCurrent: {
      color: "#e1b12c !important",
      boxShadow: "0 0 6px grey, 0 0 1px grey",
      borderRadius: "20px",
    },
  }));

  const classes = useStyles();

  const getStepStyle = (step) => {
    if (step === 1) {
      return classes.iconCurrent;
    }
    if (step === 0) {
      return classes.iconApproved;
    }
    return classes.iconWaiting;
  };

  const sendLightbox = (data) => {
    setLightbox({
      ...lightbox,
      images: [data],
      open: true,
      index: 0,
    });
  };

  useEffect(() => {
    const LINK = company.externalLoginUrl || "/login";

    const token = getQueryStringValue("u");

    authByForeignToken(company.label, token).then((validate) => {
      if (!validate) {
        brokenLink(window.location.href).then(() => {
          window.open(`${LINK}`, "_self");
        });
      } else if (validate.error) {
        brokenLink(window.location.href).then(() => {
          window.open(`${LINK}`, "_self");
        });
      } else {
        authenticate(validate, () => {
          if (isAuth()) {
            validateGift("tok_stok", label, projectTemplatesHash)
              .then((data) => {
                if (
                  data.error &&
                  data.error ===
                    "Cupom de desconto não encontrado ou fora de validade"
                ) {
                  window.open("/environments-list", "_self");
                }
                getUser()
                  .then((user) => {
                    setUser({
                      ...user,
                      profile: {
                        ...user.profile,
                        phone: getFormattedPhone(user.profile.phone),
                      },
                    });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              })
              .catch(() => {
                history.replace("/environments-list");
              });
          }
        });
      }
      getQuestionByHash(projectTemplatesHash, "tok_stok").then((res) => {
        setQuestionInfo(res);
      });
    });
  }, []);

  function isInputValid(field, value) {
    let fieldValidations = formValidations[field].validators;
    let result = fieldValidations.reduce((isValid, nextValidation) => {
      return isValid && nextValidation(value, user);
    }, true);
    if (formValidations[field].postValidate) {
      formValidations[field].postValidate(result);
    }
    return result;
  }

  function onInputChange(name, value) {
    if (isInputValid(name, value)) {
      formValidations[name].error = false;
    } else {
      formValidations[name].error = true;
    }
    setFormValidations({
      ...formValidations,
    });
  }

  function required(value) {
    return !!value;
  }

  function isFieldValid(validatorName, accessor) {
    let value = getDescendantProp(user, accessor ? accessor : validatorName);
    let fieldValidations = formValidations[validatorName].validators;
    let result = fieldValidations.reduce((isValid, nextValidation) => {
      return isValid && nextValidation(value, user);
    }, true);
    return result;
  }

  function isFormValid() {
    let keys = Object.keys(formValidations);
    return keys.reduce((isValid, key) => {
      return isValid && formValidations[key].isValid;
    }, true);
  }

  function validate() {
    let fieldNames = Object.keys(formValidations);
    let validations = fieldNames.reduce((acc, current) => {
      const accessor = formValidations[current].accessor;
      acc[current] = isFieldValid(current, accessor);
      return acc;
    }, {});
    applyValidationsToForm(validations);
  }

  function applyValidationsToForm(validations) {
    let keys = Object.keys(formValidations);
    keys.forEach((key) => {
      formValidations[key].isValid = validations[key];
      if (!validations[key]) {
        formValidations[key].error = true;
      }
    });
    setUser({
      ...user,
    });
  }

  function getHtmlValidations(key) {
    return {
      [typeof formValidations[key].error === "undefined"
        ? "neutral"
        : formValidations[key].error
        ? "invalid"
        : "valid"]: "true",
    };
  }

  function confirmProfileValidation(e) {
    e.preventDefault();
    validate();

    if (isFormValid()) {
      setIsLoading(true);
      updateUser(user._id, {
        profile: {
          ...user.profile,
          phone: `+55${user.profile.phone.replace(/\D/g, "")}`,
          document: user.profile.document.replace(/[^0-9]/g, ""),
        },
      })
        .then(() => {
          createProjectByHashAsGift(label, projectTemplatesHash)
            .then((res) => {
              setIsLoading(false);
              window.open(`/environments-list?show=${res._id}`, "_self");
            })
            .catch((err) => {
              toast.error(err.message);
              setIsLoading(false);
            });
        })
        .catch((err) => {
          toast.error(err.message);
          setIsLoading(false);
        });
    }
    return false;
  }
  const getStepTextStyle = (index) => {
    if (index === 1) {
      return {
        color: "black",
        fontSize: "15px",
      };
    }
    return {
      color: "rgba(0, 0, 0, 0.54)",
      fontSize: "15px",
    };
  };

  return user._id ? (
    <Container
      fluid
      className="main-content-container p-0 mx-auto m-0"
      style={{ maxWidth: "800px" }}
    >
      <ToastContainer />
      <Row>
        <Col lg="12">
          <Card className="mt-5">
            <CardHeader className="border-bottom">
              <div style={{ width: "100%" }} id="stripper-gift">
                <Stepper activeStep={1} alternativeLabel>
                  {steps.map((label, idx) => (
                    <Step key={idx}>
                      <StepLabel
                        StepIconProps={{
                          classes: {
                            root: getStepStyle(idx),
                          },
                        }}
                      >
                        <span style={getStepTextStyle(idx)}>{label}</span>
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <div
                  style={{
                    backgroundImage: `url("${require("../images/presente.png")}")`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                    height: "84px",
                    width: "84px",
                  }}
                />
              </div>
              <h3 className="text-center">
                Você recebeu um serviço de decoração online de presente!
              </h3>
              <div className="d-flex justify-content-center align-items-center mb-2">
                <div
                  role="button"
                  tabIndex="0"
                  alt=""
                  onKeyDown={() => {}}
                  className="clickable"
                  onClick={() => {
                    sendLightbox(`${BUCKET_URL}/${questionInfo?.thumbnail}`);
                  }}
                  style={{
                    backgroundImage: `url("${BUCKET_URL}/${questionInfo?.thumbnail}")`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                    height: "184px",
                    width: "184px",
                  }}
                />
              </div>

              <p className="text-center" style={{ fontSize: "16px" }}>
                Confirme suas informações para iniciar a sua assessoria
              </p>
            </CardHeader>
            <CardBody>
              <Form onSubmit={confirmProfileValidation}>
                <div className="form-group">
                  <label htmlFor="gift-email-input">Email</label>
                  <FormInput
                    id="gift-email-input"
                    type="text"
                    className="form-control"
                    disabled={true}
                    required
                    onChange={(ev) =>
                      setUser({ ...user, email: ev.target.value })
                    }
                    name="email"
                    value={user.email}
                    placeholder="Digite seu email"
                    {...getHtmlValidations("email")}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="gift-first-name-input">Primeiro nome</label>
                  <FormInput
                    id="gift-first-name-input"
                    type="text"
                    className="form-control"
                    required
                    disabled={isLoading}
                    onChange={(ev) => {
                      setUser({
                        ...user,
                        profile: {
                          ...user.profile,
                          firstName: ev.target.value,
                        },
                      });
                      onInputChange("firstName", ev.target.value);
                    }}
                    name="firstName"
                    value={user.profile.firstName}
                    {...getHtmlValidations("firstName")}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="gift-last-name-input">Último nome</label>
                  <FormInput
                    id="gift-last-name-input"
                    type="text"
                    className="form-control"
                    required
                    disabled={isLoading}
                    onChange={(ev) => {
                      setUser({
                        ...user,
                        profile: {
                          ...user.profile,
                          lastName: ev.target.value,
                        },
                      });
                      onInputChange("lastName", ev.target.value);
                    }}
                    name="lastName"
                    value={user.profile.lastName}
                    {...getHtmlValidations("lastName")}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="gift-cpf-cnpj-input">CPF</label>
                  <CpfCnpj
                    type="text"
                    className="form-control"
                    disabled={isLoading}
                    required
                    onChange={(document) => {
                      setUser({
                        ...user,
                        profile: {
                          ...user.profile,
                          documentType: document.type,
                          document: document.value,
                        },
                      });
                      onInputChange("document", document.value);
                    }}
                    trackname="documento"
                    name="document"
                    value={user.profile.document}
                    placeholder="999.999.999-99"
                    {...getHtmlValidations("document")}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="gift-phone-input">Telefone</label>
                  <PhoneBR
                    required
                    disabled={isLoading}
                    value={user.profile.phone}
                    onChange={(phone) => {
                      setUser({
                        ...user,
                        profile: {
                          ...user.profile,
                          phone: phone,
                        },
                      });
                      onInputChange("phone", phone);
                    }}
                    placeholder="Informe seu telefone"
                    autoComplete="phone"
                    name="phone"
                    className="form-control"
                    {...getHtmlValidations("phone")}
                  />
                </div>

                <div style={{ display: "grid" }}>
                  <button
                    type="submit"
                    className="btn btn-custom-primary mt-3"
                    data-gtm-event-category="tokstok:decora:home"
                    data-gtm-event-action="clique:botao:confirmacao-dados"
                    data-gtm-event-label="li-e-aceito-os-termos"
                    disabled={isLoading}
                    style={{
                      backgroundColor: "rgb(10, 119, 90)",
                      borderColor: "rgb(10, 119, 90)",
                      color: "white",
                      fontSize: "20px",
                    }}
                  >
                    {isLoading
                      ? "Iniciando assessoria..."
                      : "Iniciar assessoria"}
                  </button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {lightbox.open && (
        <ShowLightbox lightbox={lightbox} setLightbox={setLightbox} />
      )}
    </Container>
  ) : (
    <div style={{ marginTop: "2%" }}>
      <Row className="mt-5 mb-5">
        <Col
          sm={{ size: 6, order: 2, offset: 5 }}
          xs={{ size: 4, order: 4, offset: 2 }}
          className="mt-5"
        >
          <img
            id="mmain-logo"
            className="align-center"
            src={require("../images/tokstok.svg").default}
            alt="Tok&Stok"
            style={{ maxHeight: "5vh" }}
          />
        </Col>
      </Row>
      <Row className="mt-5">
        <Col xs="12">
          <LoadingOverlay active={true} spinner={<BounceLoader />} />
        </Col>
      </Row>
      <Row className="mt-5">
        <Col xs="12" className="text-align-center mt-5">
          <p>Olá!</p>
          <p>
            Aguarde um instante e iremos redirecionar você para dar continuidade
            ao processo.
          </p>
          <p>Obrigado!</p>
        </Col>
      </Row>
    </div>
  );
}

export default Gift;
